/* eslint-disable */
<template>
  <v-wait for="product-creating">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>Ürün Oluşturuluyor...</p>
      </div>
    </template>
    <div class="container-fluid mt-4">
      <div class="row">
        <div class="col-md-4 border-right">
          <h5 class="mb-4">Ürün Bilgileri</h5>
          <div class="form-group mb-4">
            <label for="product-name">Ürün Adı</label>
            <input type="text" class="form-control" v-model="productName" id="product-name">
          </div>
          <div class="form-group mb-4">
            <label for="product-description">Ürün Açıklaması</label>
            <textarea rows="2" class="form-control" v-model="productDescription" id="product-description"></textarea>
          </div>
          <div class="form-group mb-4">
            <label for="product-description">Hedef Ürün / Malzeme</label>
            <select class="custom-select" v-model="resultMalzemeId">
              <option selected value="0">Malzeme Seçiniz...</option>
              <option :value="malzeme.MALZEME_ID" v-for="(malzeme, index) in malzemeler" v-bind:key="'malzeme-res-'+ index">
                {{malzeme.MALZEME_CODE + ' - ' + malzeme.MALZEME_NAME}}</option>
            </select>
          </div>
          <div class="form-group mb-4">
            <button class="btn btn-block btn-primary" @click="insertProduct()">Ürünü Kaydet</button>
          </div>
        </div>
        <div class="col-md-4 border-right">
          <h5 class="mb-4">Malzemeler</h5>
          <div class="form-group mb-4">
            <input type="text" class="form-control" placeholder="Malzeme arayın..."
              @keyup.enter="getMalzemeler()" v-model="searchFilter">
          </div>
          <v-wait for="malzemeler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Malzemeler yükleniyor...</p>
              </div>
            </template>
            <ul class="list-group bigone w-100">
              <li class="list-group-item" v-for="(malzeme, index) in malzemeler" :key="'keym'+malzeme.MALZEME_ID">
                <div class="custom-control custom-checkbox mr-sm-2">
                  <input type="checkbox" class="custom-control-input" @change="onSelectMalzeme(index, malzeme.MALZEME_ID)"
                    v-model="malzeme.CHECKED" v-bind:id="'malc' + index">
                  <label class="custom-control-label light-text" v-bind:for="'malc'+index">
                    {{malzeme.MALZEME_CODE + ' - ' + malzeme.MALZEME_NAME}}</label>
                </div>
              </li>
            </ul>
          </v-wait>
        </div>
        <div class="col-md-4">
          <h5 class="mb-4">Seçilen Malzemeler</h5>
          <ul class="list-group bigone w-100">
            <li class="list-group-item align-middle py-2" v-for="(malzeme, index) in malzemeler.filter(m => m.CHECKED == true)" :key="'keys' + malzeme.MALZEME_ID">
              <div class="form-row align-middle">
                <div class="col-7">{{malzeme.MALZEME_CODE}}</div>
                <div class="col-5">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button class="btn btn-sm btn-danger font-weight-bold"
                        @click="minus(index)" type="button" id="button-addon1">&nbsp;-&nbsp;</button>
                    </div>
                    <input type="text" class="form-control form-control-sm text-center" disabled v-model="malzeme.MALZEME_COUNT">
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-success font-weight-bold"
                        @click="add(index)" type="button" id="button-addon1">&nbsp;+&nbsp;</button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'UrunOlusturPage',
  components: {
  },
  data () {
    return {
      activeProduct: {},
      productId: 0,
      productName: '',
      productDescription: '',
      resultMalzemeId: 0,
      malzemeler: [],
      selectedMalzemeler: [],
      selectedValues: [],
      searchFilter: ''
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    getCount: function(valueIndex) { return this.selectedValues[valueIndex] || 0 },
  },
  methods: {
    getProduct() {
      console.log(this.$route.params)
      if(this.$route.params.id === undefined)
        return

      this.productId = this.$route.params.id
      this.activeProduct = {}
      this.$wait.start('product-creating')
      axios.post('/api/stok/urun?sessionid=' + this.getSessionId + '&urunId=' + this.$route.params.id)
      .then(response => {
        this.activeProduct = response.data[0]
        this.productName = this.activeProduct.URUN_NAME
        this.productDescription = this.activeProduct.URUN_DESCRIPTION
        this.resultMalzemeId = this.activeProduct.URUN_RESULT_MALZEME
        this.$wait.end('product-creating')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('product-creating')
      })
    },
    getPiecesOfProcut() {
      console.log(this.$route.params)
      if(this.$route.params.id === undefined)
        return

      this.activeProduct = {}
      this.$wait.start('malzemeler-loading')
      axios.post('/api/stok/eslesmeler?sessionid=' + this.getSessionId + '&urunId=' + this.$route.params.id)
      .then(response => {
        this.selectedMalzemeler = response.data
        console.log("malzeme adet : " + this.selectedMalzemeler.length)
        for(let i = 0; i < this.selectedMalzemeler.length; i++) {
          let msd = this.malzemeler.filter(m => m.MALZEME_ID == this.selectedMalzemeler[i].MALZEME_ID)
          if(msd != null || msd.length > 0) {
            msd[0].CHECKED = true
            msd[0].MALZEME_COUNT = this.selectedMalzemeler[i].MALZEME_COUNT
          }
        }

        console.log("malzeme adet : " + this.malzemeler.filter(m => m.CHECKED == 1).length)
        this.$wait.end('malzemeler-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('malzemeler-loading')
      })
    },
    getMalzemeler() {
      this.malzemeler = []
      this.$wait.start('malzemeler-loading')
      let sessionid = localStorage.getItem('utks-sessionid')
      axios.post('/api/stok/tum-malzemeler-lite?sessionid=' + sessionid + '&searchFilter=' + this.searchFilter,
        { 'SessionId': sessionid, 'SearchFilter': this.searchFilter })
      .then(response => {
        this.malzemeler = response.data
        for(let i = 0; i < this.malzemeler.length; i++)
          this.malzemeler[i].CHECKED = false

        this.$wait.end('malzemeler-loading')
        this.getPiecesOfProcut()
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('malzemeler-loading')
      })
    },
    insertProduct() {
      this.$wait.start('product-creating')
      let selecteds = this.malzemeler.filter(m => m.CHECKED == true);
      let insertJson = {}
      insertJson.ProductName = this.productName
      insertJson.ProductDescription = this.productDescription
      insertJson.SelectedPieces = selecteds
      insertJson.SelectedValues = selecteds.map(o => o.MALZEME_COUNT)
      insertJson.SessionId = this.getSessionId
      insertJson.ProductId = this.productId
      insertJson.ResultMalzemeId = this.resultMalzemeId

      console.log(insertJson)
      axios.post('/api/stok/urun-olustur', insertJson)
      .then(response => {
        this.$wait.end('product-creating')
        this.$router.push('/uretim/urunler')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('product-creating')
      })
    },
    onSelectMalzeme(valueIndex, malzemeId) {
      if(this.selectedMalzemeler.findIndex(m => m.MALZEME_ID == malzemeId) > -1) {
        this.selectedValues.push({'MALZEME_ID': malzemeId, 'MALZEME_COUNT': 0})
        return
      }

      let indexFind = this.selectedValues.findIndex(m => m.MALZEME_ID == malzemeId)
      this.selectedValues.splice(indexFind, 1)
    },
    add(valueIndex) {
      this.malzemeler.filter(m => m.CHECKED == true)[valueIndex].MALZEME_COUNT++;
      //this.selectedValues[valueIndex].MALZEME_COUNT++;
    },
    minus(valueIndex) {
      if(this.malzemeler.filter(m => m.CHECKED == true)[valueIndex].MALZEME_COUNT > 0)
        this.malzemeler.filter(m => m.CHECKED == true)[valueIndex].MALZEME_COUNT--;
      //if(this.selectedValues[valueIndex].MALZEME_COUNT > 0)
      //this.selectedValues[valueIndex].MALZEME_COUNT--;
    }
  },
  mounted() {
    this.getMalzemeler()
    this.getProduct()
  }
}
</script>

<style scoped>

  .bigone {    
      display: flex;
      /* min-height: 100vh;   <-- REMOVE */
      height: 576px;       /* <-- NEW   */
      flex-direction: column;
  }

  .fixed-height-col {
    display: flex;
    height: calc(100vh - 200px);
  }

  ul.list-group {
    display: inline-block !important;
    height: calc(100vh - 300);
    max-height: 100% !important;
    overflow-y: scroll;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/UrunOlusturPage.vue